<div class="progress-dot"></div>
<div class="progress-dot"></div>
<div class="progress-dot"></div>